import { Badge, Tooltip, Text, Flex, Box } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";

function formatCountdown(ms) {
  if (ms <= 0) {
    return "00:00:00";
  }
  const totalSeconds = Math.floor(ms / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
}

function AppAvailabilityBadge({ activatedAt, autoCloseDays }) {
  const MS_IN_A_DAY = 24 * 60 * 60 * 1000;

  const closeAt = useMemo(() => {
    if (!activatedAt || !autoCloseDays) return null;
    return new Date(activatedAt).getTime() + autoCloseDays * MS_IN_A_DAY;
  }, [activatedAt, autoCloseDays]);

  const [display, setDisplay] = useState(null);

  useEffect(() => {
    if (!closeAt) {
      setDisplay(
        autoCloseDays && !activatedAt ? `${autoCloseDays} days` : null
      );
      return;
    }

    const update = () => {
      const diffMs = closeAt - Date.now();

      if (diffMs <= 0) {
        setDisplay("0 days");
        return;
      }

      const diffDays = diffMs / MS_IN_A_DAY;

      if (diffDays < 1) {
        setDisplay(formatCountdown(diffMs));
      } else {
        setDisplay(`${Math.ceil(diffDays)} days`);
      }
    };

    update();

    if (closeAt - Date.now() >= MS_IN_A_DAY) return;

    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [closeAt, autoCloseDays, activatedAt]);

  if (!display) return null;

  return (
    <Flex direction="column" style={{ flex: 1 }}>
      <Text size="sm" fw={500}>
        App Availability
      </Text>
      <Tooltip label="Contact support to extend your app availability">
        <Box w="100%">
          <Badge variant="light" color="blue" size="lg" w="100%" h={36}>
            {display}
          </Badge>
        </Box>
      </Tooltip>
    </Flex>
  );
}

export default AppAvailabilityBadge;
